import React, { useRef, useState } from 'react';

function LPSPredictionForm({ onSubmit }) {
  const fileRef   = useRef();
  const [method, setMethod] = useState('p2rank');   // 默认算法

  const handleSubmit = () => {
    const file = fileRef.current.files[0];
    if (!file) return alert('请选择一个蛋白质结构文件（.pdb/.cif）');

    const formData = new FormData();
    formData.append('proteinFile', file);   // ⚠️ 字段名必须和后端一致
    formData.append('method', method);      // p2rank | deep_lps | fpocket

    /** ──➤ 统一的 3-参数调用： */
    onSubmit('LPS 结合位点预测', formData, 'lps');
  };

  return (
    <div className="flex flex-col h-full">
      {/* 1 · 结构文件上传 */}
      <input
        type="file"
        accept=".pdb,.pdb.gz,.cif,.bcif"
        ref={fileRef}
        className="form-input"
      />

      {/* 2 · 算法选择 */}
      <select
        value={method}
        onChange={e => setMethod(e.target.value)}
        className="form-select mt-2"
      >
        <option value="p2rank">P2Rank</option>
        <option value="deep_lps">Deep-LPS</option>
        <option value="fpocket">Fpocket</option>
      </select>

      {/* 3 · 提交按钮 */}
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">
          提交任务
        </button>
      </div>
    </div>
  );
}

export default LPSPredictionForm;

